<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="font-weight-bold h4 text-muted" v-if="form_data">
        {{form_data.FormFields[0].form_name}}
        {{form_data.FormFields[0].form_description}}
      </div>
      <form v-if="form_data" class="row">
        <div
          v-for="(field,fieldKey) in form_data.FormFields"
          :key="fieldKey"
          class="col-lg-6 col-xl-4 mb-4"
        >
          <div v-if="field.form_field_type == 'text'" class="input-material">
            <label>{{field.form_field_name}}</label>
            <input
              :minlength="field.min_length"
              :maxlength="field.max_length"
              type="text"
              name="text_input"
              v-model="input_data[fieldKey]"
            />
          </div>

          <div v-if="field.form_field_type == 'textarea'">
            <label>{{field.form_field_name}}</label>
            <div class="input-material-textarea">
              <textarea
                :minlength="field.min_length"
                :maxlength="field.max_length"
                name="text_area"
                v-model="input_data[fieldKey]"
              ></textarea>
            </div>
          </div>

          <div v-if="field.form_field_type == 'number'" class="input-material">
            <label>{{field.form_field_name}}</label>
            <input
              type="number"
              :minlength="field.min_length"
              :maxlength="field.max_length"
              name="number"
              :placeholder="field.form_field_name"
              v-model="input_data[fieldKey]"
            />
          </div>
          <div v-if="field.form_field_type == 'checkbox'" class="d-flex align-items-center">
            <label class="mr-2">{{field.form_field_name}}</label>
            <b-form-checkbox name="check-button" switch v-model="input_data[fieldKey]"></b-form-checkbox>
          </div>

          <div v-if="field.form_field_type == 'rating'">
            <label class="mr-2">{{field.form_field_name}}</label>
            <star-rating v-model="rating"></star-rating>
          </div>

          <p class="error_message">{{errorMessage}}</p>
        </div>

        <div class="col-md-12 text-center">
          <button @click.prevent.stop="submit" class="btn-blue">{{ $t('submit') }}</button>
        </div>
      </form>
      <!-- <div class="row mb-5">
      <div class="col-6">
        <input
          v-model="form_name"
          name="form_name"
          v-validate="'required'"
          type="text"
          placeholder="Form Name"
        />
        <p class="error_message">
          <span v-if="errors.has('form_name')">{{ errors.first(`form_name`) }}</span>
        </p>
      </div>
      <div class="col-6">
        <textarea
          name="form_description"
          v-validate="'required'"
          v-model="form_description"
          class="col-6"
          placeholder="Form Description"
        />
        <p class="error_message">
          <span v-if="errors.has('form_description')">{{ errors.first(`form_description`) }}</span>
        </p>
      </div>
      </div>-->
      <!-- <div v-if="form_data">
        <div v-for="(field,fieldKey) in form_data.FormFields" :key="fieldKey">
          {{fieldKey}}
          <div v-if="field.priority_type == 'Compulsary'">
            <div class="mb-4" v-if="field.form_field_type == 'text'">
              <input
                :minlength="field.min_length"
                :maxlength="field.max_length"
                type="text"
                name="text_input"
                v-validate="'required'"
                :placeholder="field.form_field_name"
                v-model="input_data[fieldKey]"
              />
            </div>
            <div class="mb-4" v-if="field.form_field_type == 'textarea'">
              <textarea
                :minlength="field.min_length"
                :maxlength="field.max_length"
                name="text_area"
                v-validate="'required'"
                :placeholder="field.form_field_name"
                v-model="input_data[fieldKey]"
              />
            </div>
            <div class="mb-4" v-if="field.form_field_type == 'number'">
              <input
                type="number"
                :minlength="field.min_length"
                :maxlength="field.max_length"
                name="number"
                v-validate="'required'"
                :placeholder="field.form_field_name"
                v-model="input_data[fieldKey]"
              />
            </div>
            <div class="mb-4" v-if="field.form_field_type == 'checkbox'">
              {{field.form_field_name}}&nbsp;
              <input type="checkbox" v-model="input_data[fieldKey]" />
            </div>
            <div class="mb-4" v-if="field.form_field_type == 'rating'">
              {{field.form_field_name}}&nbsp;
              <star-rating v-model="rating"></star-rating>
            </div>
          </div>
          <div v-else>
            <div class="mb-4" v-if="field.form_field_type == 'text'">
              <input
                :minlength="field.min_length"
                :maxlength="field.max_length"
                type="text"
                name="text_input"
                :placeholder="field.form_field_name"
                v-model="input_data[fieldKey]"
              />
            </div>
            <div class="mb-4" v-if="field.form_field_type == 'textarea'">
              <textarea
                :minlength="field.min_length"
                :maxlength="field.max_length"
                name="text_area"
                :placeholder="field.form_field_name"
                v-model="input_data[fieldKey]"
              />
            </div>
            <div class="mb-4" v-if="field.form_field_type == 'number'">
              <input
                type="number"
                :minlength="field.min_length"
                :maxlength="field.max_length"
                name="number"
                :placeholder="field.form_field_name"
                v-model="input_data[fieldKey]"
              />
            </div>
            <div class="mb-4" v-if="field.form_field_type == 'checkbox'">
              {{field.form_field_name}}&nbsp;
              <input type="checkbox" v-model="input_data[fieldKey]" />
            </div>
            <div class="mb-4" v-if="field.form_field_type == 'rating'">
              {{field.form_field_name}}&nbsp;
              <star-rating v-model="rating"></star-rating>
            </div>
          </div>
        </div>
        <button @click="submit">Submit</button>
      </div>-->
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StarRating from "vue-star-rating";
import Vue from "vue";

Vue.component("star-rating", StarRating);

export default {
  data() {
    return {
      form_data: null,
      form_input: null,
      input_data: [],
      form_name: "",
      form_description: "",
      rating: null,
      errorMessage: "",
    };
  },
  mounted() {
    this.getFormData();
  },
  methods: {
    // setInputs(event, ff_id) {
    //   console.log("event :", event.target.value);
    //   console.log("ff_id :", ff_id);
    // },
    getFormData() {
      const { form_id } = this.$route.params;
      MasterService.GetFormData({ form_id: form_id })
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.form_data = data.Records[0];
              console.log("this.form_data :", this.form_data);
            } else {
              vue.toasted.show(data.message || "Please try later");
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    submit() {
      let flag = true;
      this.form_data.FormFields.map((formField, index) => {
        console.log("formField :", formField);
        if (formField.priority_type == "Compulsary") {
          console.log("this.input_data[index] :", this.input_data[index]);
          if (this.input_data[index] == undefined) {
            // this.errorMessage = "please fill in all required fields";
            this.$toasted.show("enter details");
            console.log("enter details  :");
            flag = false;
            return;
          }
        }
      });
      if (flag) {
        const { form_id } = this.$route.params;
        let input = [];
        for (let i in this.form_data.FormFields) {
          input.push({
            ff_id: this.form_data.FormFields[i].ff_id,
            input_data: this.input_data[i],
          });
        }
        console.log("input :", input);
        MasterService.InsertFormInput({
          form_id: form_id,
          form_name: this.form_name,
          form_description: this.form_description,
          input_array: input,
        })
          .then((response) => {
            const { data } = response;
            if (data.status) {
              this.$toasted.show(data.message);
              this.$router.push({ name: "Feedback Forms" });
            } else {
              // Show Errors
              this.$toasted.show(data.message);
            }
          })
          .catch((error) => {
            // Show Catch Error
            this.$toasted.show(error);
          });
      }
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/SendFeedbackComponents/sendFeedback.vue